var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMobileNav
    ? _c(
        "div",
        {
          staticClass:
            "look_userLoginHander  look_metaNavRightContent__item  look_metaNavRightContent__item--2"
        },
        [
          !_vm.isLoggedIn
            ? _c("ul", { staticClass: "look_metaNavLogin" }, [
                _c("li", { staticClass: "look_headerLogin" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        "data-toggle": "modal",
                        href: _vm.isLogin ? "javascript:void(0)" : "#login",
                        "data-toggle": _vm.isLogin ? false : "modal",
                        "aria-label": _vm.$translate("Ceres::Template.login")
                      },
                      on: {
                        click: function($event) {
                          _vm.createLoginModal()
                          _vm.unmarkInputFields()
                        }
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "HoferAntikschmuck::Template.headerLogin"
                            )
                          )
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "look_headerRegister" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        "data-toggle": "modal",
                        href: _vm.isRegister
                          ? "javascript:void(0)"
                          : "#registration",
                        "data-toggle": _vm.isRegister ? false : "modal",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.loginRegister"
                        )
                      },
                      on: {
                        click: function($event) {
                          _vm.createRegisterModal()
                          _vm.unmarkInputFields()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "HoferAntikschmuck::Template.headerRegister"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c("ul", { staticClass: "look_metaNavLogin isLoggedIn d-flex" }, [
                _c("li", { staticClass: "look_metaNavLogin__li-1" }, [
                  _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "HoferAntikschmuck::Template.headerMyAccount"
                          )
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "look_metaNavLogin__li-2" }, [
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      attrs: { href: "#" }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "HoferAntikschmuck::Template.headerLogout"
                            )
                          )
                        )
                      ])
                    ]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    : _c("li", [
        !_vm.isLoggedIn
          ? _c(
              "a",
              {
                attrs: {
                  "data-toggle": "modal",
                  href: _vm.isLogin ? "javascript:void(0)" : "#login",
                  "data-toggle": _vm.isLogin ? false : "modal",
                  "aria-label": _vm.$translate("Ceres::Template.login")
                },
                on: {
                  click: function($event) {
                    _vm.createLoginModal()
                    _vm.unmarkInputFields()
                  }
                }
              },
              [
                _c("svg", { attrs: { stroke: "currentColor" } }, [
                  _c("use", { attrs: { "xlink:href": "#user" } })
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "HoferAntikschmuck::Template.headerLogin"
                        )
                      ) +
                      "\n\t\t\t"
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isLoggedIn
          ? _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
              _c("svg", { attrs: { stroke: "currentColor" } }, [
                _c("use", { attrs: { "xlink:href": "#user" } })
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$translate(
                        "HoferAntikschmuck::Template.headerMyAccount"
                      )
                    ) +
                    "\n\t\t\t"
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isLoggedIn
          ? _c(
              "a",
              {
                directives: [{ name: "logout", rawName: "v-logout" }],
                staticClass: "logout",
                attrs: { href: "#" }
              },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.$translate("HoferAntikschmuck::Template.headerLogout")
                    ) +
                    "\n\t\t"
                )
              ]
            )
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }